<template>
	<div id="app" :class="bodyClasses">
		<keep-alive>
			<api-client></api-client>
		</keep-alive>
		<keep-alive>
			<echo-client></echo-client>
		</keep-alive>

		<div :class="containerClasses">
			<div class="alert alert-danger alert-error" v-if="error">
				<strong>Fejl:</strong> <span v-text="error" />
				<button class="btn btn-danger btn-close btn-sm" v-on:click="clearError">&times;</button>
			</div>

			<router-view />
		</div>
	</div>
</template>

<script>
	import EchoClient from './components/app-components/echo-client';
	import ApiClient from './components/app-components/api-client';
	import {mapGetters} from 'vuex';
	import * as MutationTypes from '@/store/mutation-types'

	export default {
		components: {
			EchoClient,
			ApiClient,
		},
		data() {
			return {
				bodyClasses: [],
				containerClasses: [],
			}
		},
		mounted() {
			console.log('process.env', process.env);

			this.updateClassesFromRoute();
		},
		computed: {
			...mapGetters({
				error: 'getError',
			}),
		},
		watch: {
			'$route': {
				deep: true,
				handler() {
					this.updateClassesFromRoute();
				}
			}
		},
		methods: {
			updateClassesFromRoute() {
				let mainPage = null;
				let childPage = null;

				if (this.$route.meta) {
					if (this.$route.meta.hasOwnProperty('mainPage') && this.$route.meta.mainPage) {
						mainPage = this.$route.meta.mainPage;
					}

					if (this.$route.meta.hasOwnProperty('childPage') && this.$route.meta.childPage) {
						childPage = this.$route.meta.childPage;
					}
				}

				let bodyClasses = [];

				if (mainPage) {
					bodyClasses.push('main-page-' + mainPage);
				}

				if (childPage) {
					bodyClasses.push('child-page-' + childPage);
				}

				let containerClasses = [];

				if (mainPage === 'manager' && childPage === 'results') {
					containerClasses.push('container-fluid');
				} else {
					containerClasses.push('container');
				}

				this.bodyClasses = bodyClasses
				this.containerClasses = containerClasses;
			},
			clearError() {
				this.$store.commit(MutationTypes.SET_ERROR, null);
			}
		}
	}
</script>

<style lang="scss">
	@import "@/styles/main.scss";

	html, body {
		height: 100%;
		background: #E3EBEF !important;
		padding: 0;
		margin: 0;
	}

	#app {
		font-family: Publik,Gibson,gibsonRegular,Arial,sans-serif;;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;

		padding: 10px;
		overflow-x: hidden;
		width: 100%;
		min-height: 100%;

		&.main-page-manager {
			&.child-page-results {
				background: url("~@/assets/bg_cropped_colorised.png");
				background-size: cover;
				overflow-y: hidden;
			}
		}

		&.main-page-client {

		}
	}

	.alert-error {
		min-height: 53px;
	}
	.btn-close {
		position: absolute;
		top: 10px;
		right: 10px;
	}

	h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
		font-weight: bold !important;
	}
</style>
